import styled from 'styled-components';
import { FolderClosed } from 'ui/icons/action/FolderClosed';
import { spacing } from 'ui/theme';

type ToastProps = {
  children: React.ReactNode;
};

const MessageWrap = styled.span`
  line-height: ${spacing.plusHalf};
  & {
    svg {
      position: relative;
      top: ${spacing.eighth};
    }
  }
`;

const NoBreak = styled.span`
  white-space: nowrap;
`;

export const NamedFolder = ({ name }: { name: string }) => (
  <NoBreak>
    <FolderClosed height={16} width={20} /> {name}
  </NoBreak>
);
export const ResponseWrapper = ({ children }: ToastProps) => {
  return <MessageWrap>{children}</MessageWrap>;
};
